/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeDiffCurrentMode } from './workingModeDiffCurrentMode';
import type { WorkingModeDiffTarget } from './workingModeDiffTarget';
import type { WorkingModeActivity } from './workingModeActivity';
import type { WorkingModeBlockedItem } from './workingModeBlockedItem';

export interface WorkingModeDiff {
  currentMode: WorkingModeDiffCurrentMode;
  target: WorkingModeDiffTarget;
  empty: boolean;
  activities?: WorkingModeActivity[];
  blocked?: WorkingModeBlockedItem[];
}
